module.exports = vendors_library;